import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../redux/store";
import { refreshToken } from "../redux/features/auth/authSlice";
import {
  fetchAndSaveSubscriptionsFromServer,
  getSubscribedProductNames,
  routeToProduct,
} from "../features/payment/SubscriptionInfo";
import { getAccessToken, getRefreshToken, isTokenExpired } from "../utils/auth";

export const ProtectedRoute = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(true); // assume public unless proven otherwise

  const location = useLocation();

  useEffect(() => {
    const checkTokenAndSubscription = async () => {
      const accessToken = getAccessToken();
      const refreshTokenValue = getRefreshToken();

      if (accessToken || refreshTokenValue) {
        try {
          // ---- AUTH CHECK ----
          let authenticated = false;

          if (accessToken && !isTokenExpired(accessToken)) {
            authenticated = true;
          } else if (refreshTokenValue) {
            const resultAction = await dispatch(refreshToken());
            authenticated = refreshToken.fulfilled.match(resultAction);
          }

          setIsAuthenticated(authenticated);

          // ---- SUBSCRIPTION CHECK ----
          if (authenticated) {
            const requiredProduct = routeToProduct[location.pathname];
            let subscribedProducts = getSubscribedProductNames();
            if (!subscribedProducts || subscribedProducts.length === 0) {
              try {
                subscribedProducts =
                  await fetchAndSaveSubscriptionsFromServer();
              } catch (err) {
                subscribedProducts = [];
              }
            }
            if (!requiredProduct || requiredProduct === "*") {
              // route doesn’t need subscription
              setHasAccess(true);
            } else {
              setHasAccess(subscribedProducts.includes(requiredProduct));
            }
          } else {
            setHasAccess(false);
          }
        } catch (error) {
          console.error("Error decoding token or refreshing:", error);
          setIsAuthenticated(false);
          setHasAccess(false);
        }
      } else {
        setIsAuthenticated(false);
        setHasAccess(false);
      }
      setLoading(false);
    };

    checkTokenAndSubscription();
  }, [dispatch, location.pathname]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ message: "Please log in to continue" }}
        replace
      />
    );
  }

  if (!hasAccess) {
    return (
      <Navigate
        to="/plans"
        state={{ message: "You must be subscribed to access GPlan." }}
        replace
      />
    );
  }

  return <Outlet />;
};
